import './index.scss';

import FormSubmitToggle from 'utils/form_submit_toggle';
new FormSubmitToggle('#registration_form', true);
